import SalidaTrasladoService from "@/services/inventario/SalidaTrasladoService";

const fetch = (context, params) => {
  return SalidaTrasladoService.fetch(params)
    .then(res => {
      context.commit('SALIDAS_TRASLADO', res.data);
    });
};

const para_entrada_por_traslado = (context, params) => {
  return SalidaTrasladoService.para_entrada_por_traslado(params)
    .then(res => {
      context.commit('SALIDAS_TRASLADO', res.data);
    });
};

export default {
  fetch,
  para_entrada_por_traslado,
};